import * as bleed from './download-bleeds-settings';
import { constants as config } from '@config';

class DownloadStorageManage {
  /**
   * Handle the download modal Session Storage
   */
  constructor () {
    this.id = INKIVE.C.BOOK.id;
    this.storeData = null;
    this.pdfUnit = [
      'cm',
      'mm',
      'in'
    ];
    this.jpgUnit = 'px';
    this.downloadType = this.getDownloadFormat();
    this.urlId;
  }

  /**
   * Get by template id the download type
   * @returns {string} Download format string.
   */
  getDownloadFormat () {
    const index = this.findIndexOfStorageByKey('selectedFormat');
    if (index === -1) {
      return this.decideFormat();
    } else {
      return this.currentStorage('selectedFormat')[index].downloadType;
    }
  }

  /**
   * Decide what is the format for new templates
   * @returns {string} the name of the format
   */
  decideFormat () {
    const backgroundColor = document.getElementById(config.background.color)?.getAttribute('fill');
    const unit = INKIVE.C.BLEED_VALUES?.bleedUnit || 'pdf-print';

    let type;

    if (backgroundColor === 'none') {
      type = 'png';
    } else if (this.pdfUnit.includes(unit)) {
      type = 'pdf-print';
    } else if (unit === this.jpgUnit) {
      type = 'jpg';
    } else {
      type = 'pdf-print';
    }

    return type;
  }

  /**
   * Get sessions storage
   * @param { ('selectedFormat' | 'lastFormat' | 'downloadOptions' | 'pages-to-dowload') } storageName
   * @returns { [ { id: '', downloadType: ''}] | [ { downloadType: '', checkbox: [{string: boolean } ] } | string}
   * Object storage in selectedFormat.
   */
  currentStorage (storageName) {
    this.currentStorageName = storageName;
    return JSON.parse(sessionStorage.getItem(storageName));
  }

  /**
   * Get the index of storage information filtering by a key
   * @param { ('selectedFormat' | 'lastFormat' | 'downloadOptions' | 'pages-to-dowload') } storageName
   * @returns {number|-1} Index or -1 if doesn't exist on storage.
   */
  findIndexOfStorageByKey (storageName) {
    let key;
    switch (storageName) {
      case 'downloadOptions':
        key = 'downloadType';
        break;
      case 'pages-to-dowload':
        key = 'urlId';
        break;
      default:
        key = 'id';
        break;
    }
    const storage = this.currentStorage(storageName);
    if (storage) {
      for (let i = 0; i < storage.length; i++) {
        if (this[key] === storage[i][key]) {
          return i;
        }
      }
    }

    return -1;
  }

  /**
   * Update Storage base on the last storage it was get
   * @param {{id: '', downloadType: ''} | {downloadType: '', checkbox: [{string: boolean}, ]} | string}  data
   */
  updateStorage () {
    sessionStorage.setItem(this.currentStorageName, JSON.stringify(this.storeData));
  }

  /**
   * Prepare an input or string to save accordingly with storage.
   * @param { ('selectedFormat' | 'lastFormat' | 'downloadOptions') } storage
   * @param {*} field input element or text
   * @returns {*}
   */
  filterDataToStore (storage, field) {
    let data;
    let newData;
    let dataTemplate;
    const index = this.findIndexOfStorageByKey(storage);
    const currentData = this.currentStorage(storage) || [];
    switch (storage) {
      case 'selectedFormat':
        dataTemplate = index === -1
          ? {
              id: this.id
            }
          : currentData[index];
        dataTemplate.downloadType = field;
        data = this.updateData(currentData, dataTemplate, index);
        break;
      case 'downloadOptions':
        dataTemplate = index === -1
          ? {
              checkBox: {},
              downloadType: this.downloadType
            }
          : currentData[index];
        newData = this.downloadOptionsData(field, dataTemplate, storage);
        data = this.updateData(currentData, newData, index);
        break;
      case 'pages-to-dowload':
        if (currentData && currentData[index]) {
          data = currentData;
          data[index].pages = field;
        } else {
          newData = {
            pages: field,
            urlId: this.urlId
          };
          if (currentData) {
            data = currentData;
            data.push(newData);
          } else {
            data = [newData];
          }
        }
        break;
      default:
        data = { field: field };
        break;
    }
    return data;
  }

  /**
   * Check if the data exist to be update or create a new one
   * @param {* | []} data data contain on the storage or empty array
   * @param {*} newData data to be saved
   * @param {*} index the index on the storage or -1
   * @returns {*} update data
   */
  updateData (data, newData, index) {
    if (index === -1) {
      data.push(newData);
    } else {
      data[index] = newData;
    }
    return data;
  }

  /**
   *
   * Set on Download modal saved inputs.
   * @returns
   */
  setSavedDownloadInputs () {
    const downloadStorageOptions = this.getStorageTemplate('downloadOptions');

    if (downloadStorageOptions) {
      const downloadStorageCheckBoxKeys = Object.keys(downloadStorageOptions.checkBox);
      for (let i = 0; i < downloadStorageCheckBoxKeys.length; i++) {
        const input = document.querySelector(`div[data-id=download] input[name="${downloadStorageCheckBoxKeys[i]}"]`);
        input.checked = downloadStorageOptions.checkBox[downloadStorageCheckBoxKeys[i]];
      }

      const bleedUnit = INKIVE.C.BLEED_VALUES.bleedUnit;

      document.querySelector('#manualBleedValue').value = downloadStorageOptions.manualBleedValue
        ? downloadStorageOptions.manualBleedValue
        : bleed.bleedDefaultValues[bleedUnit];

      const downloadFormat = this.getDownloadFormat();

      if (downloadStorageOptions.checkBox.includeManualBleed && downloadFormat === 'pdf-print') {
        const radioBleedType = document.querySelectorAll('div[data-id=download] li.filter-bleed-type');
        radioBleedType.forEach(radioBleedType => { radioBleedType.classList.remove('hidden'); });
        bleed.showCanvasBleed();
        bleed.setLastSavedBleedOptionsValue();
      }
    }
  }

  /**
   *
   * @param { ('selectedFormat' | 'lastFormat' | 'downloadOptions' | 'pages-to-dowload') } storageName
   * @returns {*=} Storage of the specific template if exist
   */
  getStorageTemplate (storageName) {
    const index = this.findIndexOfStorageByKey(storageName);
    return index !== -1 ? this.currentStorage(storageName)[index] : undefined;
  }

  /**
   * Treat the input value depend on which case, this only works
   * for downloadOptions Storage
   * @param {*} field input field
   * @param {*} data new Data to be save
   * @returns {*}
   */
  downloadOptionsData (field, data) {
    const fieldName = field.getAttribute('name');
    const otherSubOption = fieldName === 'isBleed' ? 'isAutomaticBleed' : 'isBleed';
    if (fieldName === 'isBleed' || fieldName === 'isAutomaticBleed') {
      data.checkBox[otherSubOption] = !field.checked;
      data.checkBox[fieldName] = field.checked;
    } else if (fieldName === 'manualBleedValue') {
      data.manualBleedValue = field.value;
    } else {
      data.checkBox[fieldName] = field.checked;
    }

    return data;
  }

  setUrlValue () {
    const urlParam = new URLSearchParams(window.location.search);
    this.urlId = urlParam.get('id');
  }

  /**
   * Checking if the value exists and save the changes or create a new information.
   * @param {*} field HTML element
   * @param {('selectedFormat' | 'lastFormat' | 'downloadOptions' | 'pages-to-dowload')} store Name of the storage
   */
  saveFieldOnStore (field, store) {
    this.currentStorageName = store;
    this.storeData = this.filterDataToStore(store, field);
    this.updateStorage();
  }
}

export default new DownloadStorageManage();
